import React from 'react';
import { CprDecisionType } from '../../../utils';

interface CprDetailsProps {
  cprDecision: CprDecisionType;
  setCprDecision: React.Dispatch<React.SetStateAction<CprDecisionType>>;
}
const CprDetails: React.FC<CprDetailsProps> = ({
  cprDecision,
  setCprDecision,
}) => {
  return (
    <div className="govuk-form-group">
      <h1 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--l" htmlFor="cpr-details">
          Details about the person, their legitimate representative, family
          member or carer involved in the CPR decision.
        </label>
      </h1>
      <textarea
        className="govuk-textarea"
        id="cpr-details"
        name="CprDetails"
        rows={5}
        placeholder="Add detailed description"
        aria-describedby="cpr-details"
        value={cprDecision.details}
        onChange={e => {
          setCprDecision(prev => ({
            ...prev,
            details: e.target.value,
          }));
        }}
      />
    </div>
  );
};

export default CprDetails;
